import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'areaconverter',
    standalone: true
})
export class AreaConverterPipe implements PipeTransform {
    transform(area: any, excludeArea: boolean = false, excludeUnit: boolean = false, useNbsp: boolean = false, onlyMetrics: boolean = false) {
        return AreaConverterPipe.transform(area, excludeArea, excludeUnit, useNbsp, onlyMetrics);
    }
    static transform(area: any, excludeArea: boolean = false, excludeUnit: boolean = false, useNbsp: boolean = false, onlyMetrics: boolean = false) {

        //  Excluding both area and unit gives no meaning, just flip the values...
        if (excludeArea && excludeUnit) {
            excludeArea = false;
            excludeUnit = false;
        }


        if (area === null || area === undefined) {
            return "-";
        }
        // Replace 
        if (isNaN(Number(area))) {
            area = area.replace(/\ /g, "");;
        }

        // Ensure that the passed in data is a number
        if (isNaN(Number(area))) {
            return "-";
        }
        let returnvalue: string;
        let returnUnit: string;
        if (area === 0) {
            returnvalue = "-";
            returnUnit = "";
        } else if (area < 10000) {
            returnvalue = Math.round(area).toString();
            returnUnit = "m²";
        } else if (area < 100000) {
            if (onlyMetrics) {
                returnvalue = (area / 1000000).toFixed(2);
                returnUnit = "km²";
            } else {
                returnvalue = (area / 1000).toFixed(1);
                returnUnit = "daa";
            }
            
        }
        else if (area < 10000000) {
            if (onlyMetrics) {
                returnvalue = (area / 1000000).toFixed(2);
                returnUnit = "km²";
            } else {
                returnvalue = Math.round(area / 1000).toString();
                returnUnit = "daa";
            }
            
        }
        else if (area < 100000000) {
            if (onlyMetrics) {
                returnvalue = (area / 1000000).toFixed(1);
                returnUnit = "km²";
            } else {
                returnvalue = Math.round(area / 10000).toString();
                returnUnit = "ha";
            }
            
        }
        else {
            returnvalue = Math.round(area / 1000000).toString();
            returnUnit = "km²";
            
        }

        if (excludeArea) {
            return returnUnit;
        }
        if (excludeUnit) {
            return returnvalue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, (useNbsp ? "&nbsp;" : " "));
        }
        return returnvalue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, (useNbsp ? "&nbsp;" : " ")) + (useNbsp ? "&nbsp;" : " ") + returnUnit;



    }
}